(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('module/slides/end.html', '<div class=\"slide slide--bg-side slide--{{ slide.type }}\">\n	<div class=\"slide_inner\">\n\n		<figure class=\"slide_bg-image\" ng-if=\"moduleImage\" ng-style=\"{\'background-image\': \'url({{moduleImage}})\'}\"></figure>\n\n		<div class=\"v-align\">\n			<div class=\"slide_content\">\n				<div class=\"text-cnt\">\n					<h1 ng-if=\"slide.title\" class=\"slide_title\">{{ slide.title }}</h1>\n					<a ng-click=\"moduleFinished()\" ng-href=\"{{overview}}\" class=\"btn btn--large btn--theme-reverse\"><span>Ga verder</span></a>\n				</div>\n			</div>\n		</div>\n\n	</div>\n</div>\n');
    }]);
})();